// Utilidades de data da semana (os dias "6 atrás → hoje" que o banco devolve
// em `semana`).

// Iniciais dos dias da semana em português (0 = domingo).
const LETRAS = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];

export interface DiaSemana {
  data: Date;
  letra: string;
  hoje: boolean;
}

// 7 datas, de 6 dias atrás até hoje.
export function diasDaSemana(base: Date = new Date()): DiaSemana[] {
  const hoje = new Date(base.getFullYear(), base.getMonth(), base.getDate());
  const out: DiaSemana[] = [];
  for (let i = 6; i >= 0; i -= 1) {
    const d = new Date(hoje);
    d.setDate(hoje.getDate() - i);
    out.push({ data: d, letra: LETRAS[d.getDay()], hoje: i === 0 });
  }
  return out;
}